import React, { useState } from "react";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";

export default ({ onChange = () => {} }) => {
  const [showAttachments, setShowAttachments] = useState(false);

  const onAttachmentSelected = (file) => {
    onChange(file);
  };

  return (
    <>
      <div
        className="element"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "center",
          color: "orange",
        }}
      >
        {!showAttachments && (
          <>
            <i
              className="fa fa-plus-circle"
              style={{
                margin: "10px",
                cursor: "pointer",
                fontSize: "30px",
              }}
              onClick={() => setShowAttachments(true)}
            ></i>
            <span className="name" onClick={() => setShowAttachments(true)}>
              Add Media
            </span>
          </>
        )}
        {showAttachments && (
          <div
            style={{
              paddingTop: "10px",
              position: "relative",
            }}
          >
            <AttachmentSelection
              videoClass={"mediaRecord"}
              attachmentClass={"mediaAttachment"}
              attachmentIconColor="orange"
              videocamIconColor="orange"
              onChange={onAttachmentSelected}
            />
            <i
              className="fa fa-close"
              style={{
                margin: "0px 9px",
                cursor: "pointer",
                position: "absolute",
                bottom: "0",
                fontSize: "20px",
                color: "black",
              }}
              onClick={() => setShowAttachments(false)}
            ></i>
          </div>
        )}
      </div>
    </>
  );
};
